export default __webpack_public_path__ + "static/media/shrutiG.babf4495.wav";